export enum SupportActionType {
  FETCH_FAQ_ITEMS = 'FETCH_FAQ_ITEMS',
  FETCH_ALL_FAQ_ITEMS = 'FETCH_ALL_FAQ_ITEMS',
  FETCH_FAQ_PAGES = 'FETCH_FAQ_PAGES',
  FETCH_KNOWLEDGE_BASE_ITEMS = 'FETCH_KNOWLEDGE_BASE_ITEMS',
  FETCH_ALL_KNOWLEDGE_BASE_ITEMS = 'FETCH_ALL_KNOWLEDGE_BASE_ITEMS',
  FETCH_NEW_ALL_KBS_ASYNC = 'FETCH_NEW_ALL_KBS_ASYNC',
  FETCH_NEW_ALL_KBS_ASYNC_SEARCH = 'FETCH_NEW_ALL_KBS_ASYNC_SEARCH',
  FETCH_NEW_ALL_FAQ_PAGES = 'FETCH_NEW_ALL_FAQ_PAGES'
}
